import Swal from 'sweetalert2';
import { quick_Action_Run_Status_Api } from '../../Apis/user/ApiConfig';
import {
    QUICK_ACTION_RUN_STATUS_ERROR,
    QUICK_ACTION_RUN_STATUS_REQUEST,
    QUICK_ACTION_RUN_STATUS_SUCCESS,
} from '../../Types/user/Types';

export const quick_Action_Run_Status_Success = (res) => {
    return {
        type: QUICK_ACTION_RUN_STATUS_SUCCESS,
        payload: res,
    };
};
export const quick_Action_Run_Status_Error = (error) => {
    return {
        type: QUICK_ACTION_RUN_STATUS_ERROR,
        error: error,
    };
};

export const quick_Action_Run_Status_Request = (res) => {
    return {
        type: QUICK_ACTION_RUN_STATUS_REQUEST,
        payload: res,
    };
};

export const quick_Action_Run_Status_ActionHandler = (
    quqcikActionId,
    runId,
) => {
    return (dispatch) => {
        dispatch(quick_Action_Run_Status_Request());
        try {
            quick_Action_Run_Status_Api(quqcikActionId, runId)
                .then((res) => {
                    if (res) {
                        if (res && res?.data && res?.status === 200) {
                            dispatch(
                                quick_Action_Run_Status_Success(res?.data)
                            );
                        } else {
                            let data = res?.response?.data?.data;
                            Swal.fire({
                                icon: 'error',
                                title: 'Oops...',
                                text: 'We are unable to complete the request the moment!',

                                confirmButtonColor: 'rgb(231,52,70)',
                            });
                            dispatch(quick_Action_Run_Status_Error(res));
                        }
                    } else {
                        dispatch(quick_Action_Run_Status_Error(''));
                    }
                })
                .catch((err) => {
                    dispatch(
                        quick_Action_Run_Status_Error('Something Went Wrong!!!')
                    );
                });
        } catch (err) {
            dispatch(quick_Action_Run_Status_Error(err));
        }
    };
};
